import { TextVariantType } from '../text/variants';
import { CheckboxVariantType, RadioButtonGroupVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    container: {
        display: 'flex',
        width: 'fit-content',
        height: 'fit-content',
        min_width: '156px',
        padding: FOUNDATIONS.spacing_150,
        border_radius: FOUNDATIONS.radius_250,
        gap: FOUNDATIONS.spacing_250,
        flex_direction: 'column',
        align_items: 'center',
        border_width: FOUNDATIONS.border_50,
        border_style: 'solid',
        background_color: FOUNDATIONS.color_comp_containers_bg,
        ...STATE_TOKENS.container,
    },
    illustrationContainer: {
        width: '100%',
        height: '100%',
        border_radius: FOUNDATIONS.radius_250,
        overflow: 'hidden',
        display: 'flex',
        justify_content: 'center',
        align_items: 'center',
    },
    titleContainer: {
        display: 'flex',
        align_items: 'center',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_150,
    },
    title: {
        font_variant: TextVariantType.FONT_PARAGRAPH_250,
        font_weight: Number(FOUNDATIONS.font_weight_caption_medium_bold),
        color: FOUNDATIONS.color_neutral_font_50,
        text_align: 'center',
        ...STATE_TOKENS.title,
    },
    selectorContainer: {
        display: 'flex',
        align_items: 'center',
    },
    checkbox: {
        variant: CheckboxVariantType.REGULAR,
    },
    radioButton: {
        variant: RadioButtonGroupVariantType.REGULAR,
    },
});
//# sourceMappingURL=commonStyles.js.map